class DateHelper {
  // json.parse 를 진행할 때 iso 8601 형식이 보이면 Date 형태로 바꾸어준다.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static dateReviver(key: unknown, value: any) {
    const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
    if (typeof value === 'string' && dateFormat.test(value)) {
      return new Date(value);
    }
    return value;
  }

  /**
   * Retrieves the current date and time as a formatted string.
   *
   * @returns {string} The current date and time in 'YYYYMMDDHHMMSS' format.
   */
  static getCurrentDateTimeStr() {
    const now = new Date();
    return DateHelper.getDateTimeStr(now);
  }

  static getDateTimeStr(date: Date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // padStart ensures two digits
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    const second = date.getSeconds().toString().padStart(2, '0');

    const datetimeString = `${year}${month}${day}${hour}${minute}${second}`;

    return datetimeString;
  }

  /**
   * 14자리 datetime 숫자를 Date 객체로 반환
   * @param dateTimeStr 14자리 숫자
   * @returns
   */
  static parseDateTimeStr(dateTimeStr: string): Date {
    // Regex pattern to match YYYYMMDDHHMMSS format
    const regexPattern = /^\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])([0-5]\d){2}$/;

    if (!regexPattern.test(dateTimeStr)) {
      throw new Error('Invalid date time string. Expected format: YYYYMMDDHHMMSS');
    }

    const year = parseInt(dateTimeStr.substring(0, 4));
    const month = parseInt(dateTimeStr.substring(4, 6)) - 1; // subtract 1 because months are 0-indexed
    const day = parseInt(dateTimeStr.substring(6, 8));
    const hour = parseInt(dateTimeStr.substring(8, 10));
    const minute = parseInt(dateTimeStr.substring(10, 12));
    const second = parseInt(dateTimeStr.substring(12, 14));

    return new Date(year, month, day, hour, minute, second);
  }
}

export default DateHelper;
